import { ChevronLeft, User, Camera } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useNavigate } from "react-router-dom";
import { BottomNav } from "@/components/BottomNav";
import { useState } from "react";

const Profile = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("John Doe");
  const [email, setEmail] = useState("john.doe@example.com");

  return (
    <div className="min-h-screen bg-background safe-area-top safe-area-bottom">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-ios-separator bg-ios-surface">
        <Button 
          variant="ghost" 
          size="icon"
          onClick={() => navigate("/settings")}
          className="text-foreground hover:bg-ios-surface-secondary w-11 h-11 rounded-full"
        >
          <ChevronLeft size={22} />
        </Button>
        <h1 className="ios-title text-foreground">Profile</h1>
        <div className="w-11" />
      </div>

      {/* Profile Content */}
      <div className="flex-1 p-4 space-y-6">
        {/* Avatar Section */}
        <div className="flex flex-col items-center py-6">
          <div className="relative">
            <div className="w-24 h-24 bg-ios-blue rounded-full flex items-center justify-center mb-4">
              <User size={48} className="text-white" />
            </div>
            <Button
              size="sm"
              className="absolute bottom-2 right-0 w-8 h-8 rounded-full bg-ios-blue text-white hover:bg-ios-blue/90"
            >
              <Camera size={16} />
            </Button>
          </div>
        </div>

        {/* Form Fields */}
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-muted-foreground mb-2 block">
              Name
            </label>
            <Input 
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="h-12 bg-ios-surface-secondary border-ios-separator text-foreground rounded-xl"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-muted-foreground mb-2 block">
              Email
            </label>
            <Input 
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12 bg-ios-surface-secondary border-ios-separator text-foreground rounded-xl"
            />
          </div>
        </div>

        {/* Save Button */}
        <Button 
          className="w-full h-12 bg-ios-blue text-white hover:bg-ios-blue/90 font-medium rounded-xl mt-8"
        >
          Save Changes
        </Button>
      </div>

      <BottomNav currentPage="settings" />
    </div>
  );
};

export default Profile;